import { render, staticRenderFns } from "./Tipo_ajustes.vue?vue&type=template&id=15ac3927"
import script from "./Tipo_ajustes.vue?vue&type=script&lang=js"
export * from "./Tipo_ajustes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports